<template>
    <div class="container-fluid" style="padding-right: 0px; padding-left: 0px;background-image: url('https://sisac.acreditacion.gob.ec/storage/Fplat.jpg') ">
        <img src="https://sisac.acreditacion.gob.ec/storage/Cenefa_superior.png" alt="" style="width: 100%; height: 18%;">
        <!-- <nav class="navbar navbar-expand-lg navbar-dark bg-primary" style="width: 100%; margin-left: 0px !important;">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01"
                aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <a class="navbar-brand" href="#">
                <img src="../img/logo_sae.png" width="150" height="40" class="d-inline-block align-top" alt="">
                Servicio de Acreditación Ecuatoriano
            </a>
            <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
                <a class="navbar-brand btn btn-info" style="border-radius: 20px;"
                    href="https://www.acreditacion.gob.ec/">Inicio</a>
                <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
                    <li class="nav-item active">
                        <a class="nav-link" href="https://sisac.acreditacion.gob.ec/">Ingresar al SISAC</a>
                    </li>
                </ul>
                <a class="navbar-brand btn btn-success" href="https://www.acreditacion.gob.ec/"
                    style="border-radius: 20px;">
                    <app-icon name="help-circle" />
                    Ayuda
                </a>
                <form class="form-inline my-2 my-lg-0">
                    <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
                    <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Buscar</button>
                </form>
            </div>
        </nav> -->
        <div class="row" >
            <div class="col-12 text-center text-secondary" style="background-image: url('https://sisac.acreditacion.gob.ec/storage/Fplat.jpg')">
                <br />
                <b>
                    <h4 style="color:#021444">Buscador de OEC Acreditados</h4>
                </b>
                <br />
            </div>
            <div class="col-12" style="background-image: url('https://sisac.acreditacion.gob.ec/storage/Fplat.jpg');">
                <app-tab :tabs="tabsHorizontal" type="horizontal" style="text-align:center; color:#131D43"  />
            </div>
        </div>
        <footer>
            <img src="https://sisac.acreditacion.gob.ec/storage/Cenefa_inferior.png" alt="" style="width: 100%; height: 15%;">
        </footer>


    </div>

</template>
<style>
.horizontal-tab .card .nav a.active {
    color: #021444;
    border-bottom: 3px solid #021444;
}
</style>
<script>
import { FormMixin } from '../../../../core/mixins/form/FormMixin';

export default {
    mixins: [FormMixin],
    data() {
        return {
            isAddEditModalActive: false,
            tabsHorizontal: [
                {
                    icon: "briefcase",
                    name: "Área de Acreditación",
                    component: "scopes-by-area",
                    permission: "",
                },
                {
                    icon: "send",
                    name: this.$t("Nombre del Organismo o Razón Social"),
                    component: "scopes-by-oec",
                    permission: "",
                },
                {
                    icon: "send",
                    name: this.$t("Filtrar por alcance (AGUAS, PETROLEOS ... ETC)"),
                    component: "scopes-by-scope",
                    permission: "",
                },
                {
                    icon: "",
                    name: "Suspensiones",
                    component: "scopes-by-discontinued",
                    permission: "",
                },
                {
                    icon: "",
                    name: "Retiros",
                    component: "scopes-by-retired",
                    permission: "",
                },
            ],
        };
    },

    created() {

    },

    methods: {

    },
};
</script>